var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.periods)?_c('div',{staticClass:"py-2"},[_c('v-select',{attrs:{"items":_vm.periods,"item-text":"text","outlined":"","return-object":"","label":"Zeitraum auswählen"},on:{"change":_vm.changeRoute},model:{value:(_vm.periodSelected),callback:function ($$v) {_vm.periodSelected=$$v},expression:"periodSelected"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }